export default {
  assign(object, source) {
    Object.keys(source).forEach(function(key) {
      object[key] = source[key];
    });
  },
  getNextNewId(array) {
    let min = 0;
    if(array) {
      for(let i = 0; i < array.length; i++) {
        let id = array[i].id;
        if(id) {
          if (!min || id < min)
			min = id;
        }
      }
    }
    return min >= 0 ? -1 : min - 1;
  },
  getLabelById(array, id) {
    if(array && id) {
      let result = array.find( a => { return a.id === id; });
      if(result)
        return result.label;
    }
    return '';
  },
  getLabelByCode(array, code) {
    if(array && code) {
      let result = array.find( a => { return a.code === code; });
      if(result)
        return result.label;
    }
    return '';
  },
  formatDate(d) {
    if(d) {
      d = new Date(d);
      var dateFormat = require('dateformat');
      return dateFormat(d, 'dd.mm.yyyy');
    }
    return '';
  },
  formatDateWithHoursAndMinutes(d) {
    if(d) {
      d = new Date(d);
      var dateFormat = require('dateformat');
      return dateFormat(d, 'dd.mm.yyyy HH:MM');
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/api/helpers/grid.js